import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';

export default function MaquinariaLayout({ user, onLogout, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, isAdmin } = usePermissions(user);

  const allTabs = [
    { name: 'Vehículos', path: '/maquinaria', permission: 'agricultura.maquinaria.inventario.view' },
    { name: 'Inspecciones', path: '/maquinaria/inspecciones', permission: 'agricultura.maquinaria.inspecciones.view' },
    { name: 'Uso de Equipos', path: '/maquinaria/uso', permission: 'agricultura.maquinaria.uso.view' },
  ];

  // Filtrar tabs según permisos
  const tabs = isAdmin ? allTabs : allTabs.filter(tab => hasPermission(tab.permission));

  return (
    <div>
      {/* Sub-tabs for Maquinaria - Responsive con scroll horizontal automático */}
      <div className="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mobile-tab-scroll -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8">
            <div className="flex gap-1 sm:gap-4 min-w-max">
              {tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                return (
                  <button
                    key={tab.path}
                    onClick={() => navigate(tab.path)}
                    className={`
                      px-3 sm:px-4 py-3 text-xs sm:text-sm font-medium transition-colors whitespace-nowrap shrink-0
                      ${isActive
                        ? 'text-emerald-600 border-b-2 border-emerald-600'
                        : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white border-b-2 border-transparent'
                      }
                    `}
                    data-testid={`maquinaria-tab-${tab.path.split('/').pop() || 'inicio'}`}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="dark:text-white">
        {children}
      </div>
    </div>
  );
}
